import { useSelector } from "react-redux";
import { RootState } from "../../store";
import CustomSelect from "../CustomSelect";

interface Props {
  value?: string | number;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  placeholder?: string;
  name?: string;
  selectClassName?: string;
  required?: boolean;
  label?: string;
  readOnly?: boolean;
  includeAll?: boolean;
}
export default function ClassSelect({
  value,
  onChange,
  placeholder,
  name,
  selectClassName,
  required,
  label,
  readOnly,
  includeAll = false,
}: Props) {
  const { accessibleClassRooms, isLoading } = useSelector(
    (state: RootState) => state.access,
  );

  const hasClasses = accessibleClassRooms?.length > 0;

  const options = hasClasses
    ? [
        ...(includeAll ? [{ label: "All", value: "" }] : []),
        ...accessibleClassRooms.map((c) => ({
          label: c.className,
          value: c.classId,
        })),
      ]
    : [{ label: "No Classes Available", value: "" }];

  return (
    <CustomSelect
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      selectClassName={selectClassName}
      label={label}
      required={required}
      options={options}
      disabled={isLoading}
      readOnly={readOnly}
    />
  );
}
